import { Pipe, PipeTransform } from '@angular/core';
import { constants } from '@constants/constants';
import moment from 'moment';

@Pipe({ standalone: false, name: 'datetime' })
export class DateTimePipe implements PipeTransform {
  constructor() {}

  transform(date: Date): string {
    if (!date) {
      return '';
    }

    return moment(date).format(constants.dateInputFormatWithTime);
  }
}
